import { createApi } from '@reduxjs/toolkit/query/react'
import { queryParams } from '../../../Utils'
import { createNeighborhoodAwareBaseQuery } from '../../../Utils/baseQuery'

export const withdrawlsApiService = createApi({
  reducerPath: 'withdrawlsApi',
  baseQuery: createNeighborhoodAwareBaseQuery('/withdrawl/'),
  endpoints: (builder) => ({
    getWithdrawls: builder.query({
      query: (args) => {
        let { id } = args

        if (id) {
          return `get/${id}`
        }

        let query = queryParams(args)

        return `get${query}`
      },
      keepUnusedDataFor: 0
    }),
    createWithdrawl: builder.mutation({
      query: (body) => ({
        url: `create`,
        method: "POST",
        body
      })
    }),
    updateWithdrawl: builder.mutation({
      query: (id) => ({
        url: `complete/${id}`,
        method: "PUT"
      })
    })
  })
})

export const {
  useGetWithdrawlsQuery,
  useCreateWithdrawlMutation,
  useUpdateWithdrawlMutation
} = withdrawlsApiService